// open-external.service.ts
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class OpenExternalService {
  private toHttpHostPath(href: string) {
    try {
      const u = new URL(href);
      return `${u.host}${u.pathname}${u.search}${u.hash}`;
    } catch { return ''; }
  }

  openInChrome(url: string) {
    const isHttps = /^https:\/\//i.test(url);
    const hostPath = this.toHttpHostPath(url);
    const scheme = isHttps ? `googlechromes://${hostPath}` : `googlechrome://${hostPath}`;
    this.launchScheme(scheme);
  }

  openInEdge(url: string) {
    const isHttps = /^https:\/\//i.test(url);
    const scheme = isHttps ? `microsoft-edge-https://${this.toHttpHostPath(url)}`
                           : `microsoft-edge-http://${this.toHttpHostPath(url)}`;
    this.launchScheme(scheme);
  }

  openInFirefox(url: string) {
    const scheme = `firefox://open-url?url=${encodeURIComponent(url)}`;
    this.launchScheme(scheme);
  }

  openInBrave(url: string) {
    const scheme = `brave://open-url?url=${encodeURIComponent(url)}`;
    this.launchScheme(scheme);
  }

  async share(url: string, title = 'Open in Browser') {
    if ((navigator as any).share) {
      try { await (navigator as any).share({ title, url }); } catch {}
    } else {
      this.copy(url);
      alert('Copied! Paste into any browser to continue.');
    }
  }

  openInNewWindow(url: string) {
    
    window.open(url, '_blank', 'noopener');
  }

  copy(text: string) {
    try { navigator.clipboard.writeText(text); } catch {
      const t = document.createElement('textarea');
      t.value = text; document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } finally { t.remove(); }
    }
  }

  private launchScheme(schemeUrl: string) {
    
    window.location.href = schemeUrl;
    
  }
}
